<template>
    <div class="clients">
      <div class="pageContent">
        <heading-wrap>
           <span slot="title">Invoices</span>
        </heading-wrap>

        <spinner v-if="loading" />
        <search-box v-model="search" name="invoices..." />

        <invoice-table :tableData="filteredInvoices" />
      </div>
    </div>
</template>

<script>
import HeadingWrap from '@/components/HeadingWrap/heading-wrap'
import ButtonCta from '@/components/Button/button'
import SlotTable from '@/components/Table/table'
import Spinner from '@/components/SpinnerIcon/spinner'
import SearchBox from '@/components/SearchBox/searchbox'
import InvoiceTable from '@/components/InvoiceTable/invoice-table'
import {modalMixin} from '@/mixins/modalMixin'
import {invoiceMixin} from '@/mixins/invoiceMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

import moment from 'moment/moment'

import { assoc, map } from 'ramda'

export default {
  name: 'Invoices',
  mixins: [invoiceMixin, modalMixin, notificationMixin],
  components: {
    HeadingWrap,
    ButtonCta,
    SlotTable,
    Spinner,
    SearchBox,
    InvoiceTable
  },
  data: () => ({
    search: ''
  }),
  computed: {
    filteredInvoices () {
      const formattedInvoices = map(item => assoc('invoicesActions', true, item), this.invoices)
      return formattedInvoices.filter(invoice => {
        var searchDate = moment(invoice.period_start.value).format('MMM YYYY').toLowerCase()
        if (invoice.external_id !== null) {
          return invoice.client.name.toLowerCase().includes(this.search.toLowerCase()) || invoice.external_id.toLowerCase().includes(this.search.toLowerCase()) || searchDate.includes(this.search.toLowerCase())
        } else {
          return invoice.client.name.toLowerCase().includes(this.search.toLowerCase()) || searchDate.includes(this.search.toLowerCase())
        }
      })
    }
  },
  methods: {
    onRowMouseOver (event) {
      event.currentTarget.classList.add('clients--active')
    },
    onRowMouseLeave (event) {
      event.currentTarget.classList.remove('clients--active')
    }
  },
  created () {
    this.startLoading()
    this.getInvoices().then(() => {
      this.finishLoading()
    }, error => {
      this.finishLoading()
      this.addNotification('danger', error)
    })
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/invoice/invoices.vue